module.exports = __webpack_public_path__ + "static/bedpost-6467f8bfa63d741f9b1f56d628669137.jpg";